export const LOCALE_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

export const toLocalDateString = (dateString: string | number) => {
  const iDate = Number.parseInt(dateString as string, 10);
  const date = isNaN(iDate) ? new Date(dateString) : new Date(iDate);

  return date.toLocaleString('nl', LOCALE_DATE_OPTIONS);
};
